import React, { useState } from "react";
import Atomic from "../../../../../AComponent/Atomic";
import { Box, Stack, Typography } from "@mui/material";
import ReadMoreTypography from "./ReadMoreComment";

const { Input, Dropdown } = Atomic;

function AssessmentForm({
  handleTabEdit,
  ActorType,
  onChangeAssessment,
  ActorUserID,
  Score,
  Achievement,
  RatingValue,
  RatingScaleValueID,
  ParameterWeightage,
  TargetRule,
  scales,
  AchievementDataType,
  disable,
  view,
  ItemNumber,
}) {
  const [state, setState] = useState({
    ActorType: ActorType,
    ActorUserID: ActorUserID,
    Score: Score,
    Achievement: Achievement,
    RatingValue: RatingValue,
    RatingScaleValueID: RatingScaleValueID,
    ItemNumber,
  });

  if (!view) {
    return <></>;
  }

  let achivementDisable = disable;
  let DropdownDisable = disable;
  const { targetType } = TargetRule;
  if (disable === false) {
    if (targetType === "AR") {
      achivementDisable = true;
    } else if (targetType === "CR") {
      DropdownDisable = true;
    }
  }

  function onChangeHandler(value, type) {
    handleTabEdit && handleTabEdit();
    setState((prevState) => {
      const newState = { ...prevState, [type]: value };
      onChangeAssessment(ActorType, newState);
      return newState;
    });
  }

  const isNumericAchivement = ["NI", "ND", "PI", "PD"].includes(
    AchievementDataType
  );

  function updateRating() {
    let Achivement = +state.Achievement;
    if (targetType === "CR") {
      handleTabEdit && handleTabEdit();
      setState((prevState) => {
        const newState = {
          ...prevState,
          RatingScaleValueID: scales[0][0],
          Achievement: Achivement,
        };
        onChangeAssessment(ActorType, newState);
        return newState;
      });
    }
  }

  return !view ? (
    <></>
  ) : disable ? (
    <Stack
      gap={"1rem"}
      direction={"row"}
      alignItems={"flex-start"}
      width={"100%"}
    >
      <Stack rowGap={"0.5rem"} alignItems={"flex-start"} width={"15rem"}>
        <Typography variant="subtitle2" color={"#00000090"}>
          {ActorType} Rating:
        </Typography>
        <Typography variant="subtitle1">
          {scales
            .map((scale) => ({
              label: scale[1],
              value: scale[0],
            }))
            .find((s) => s.value === state.RatingScaleValueID)?.label ||
            "Not found"}
        </Typography>
      </Stack>
      <Stack rowGap={"0.5rem"} alignItems={"flex-start"} width={"100%"}>
        <Typography variant="subtitle2" color={"#00000080"}>
          {ActorType} Comment:
        </Typography>
        <ReadMoreTypography text={state.Achievement || ""} />
      </Stack>
    </Stack>
  ) : (
    <Stack rowGap={"0.3rem"} alignItems={"center"}>
      <Typography
        variant="subtitle2"
        color={"#00000080"}
        justifySelf={"flex-start"}
      >
        {ActorType}
      </Typography>
      <Dropdown
        disable={DropdownDisable}
        defaultMenuOptionLabel={"Select Rating"}
        label={"Select Rating"}
        menuItems={[
          ...scales.map((scale) => ({
            label: scale[1],
            value: scale[0],
          })),
        ]}
        menuHeight="10rem"
        onChange={(value) => {
          if (value === -1) return;
          if (!ParameterWeightage) ParameterWeightage = 0;

          const scale = scales.find((scale) => scale[0] === value);
          let scaleValue = 0;
          if (scale) scaleValue = scale[3];

          handleTabEdit && handleTabEdit();
          setState((prevState) => {
            const newState = {
              ...prevState,
              Score: scaleValue,
              RatingScaleValueID: value,
            };
            onChangeAssessment(ActorType, newState);
            return newState;
          });
        }}
        value={state.RatingScaleValueID}
        required={true}
      />
      {achivementDisable ? (
        <Box sx={{ width: "15em" }}>
          {!state.Achievement ? (
            <Typography variant="subtitle2">{"No Comments added"}</Typography>
          ) : (
            <Box
              display={"flex"}
              flexDirection={"column"}
              alignItems={"flex-start"}
            >
              <Typography variant="subtitle1">Comments</Typography>
              <ReadMoreTypography text={state.Achievement} />
            </Box>
          )}
        </Box>
      ) : (
        <Input
          label={"Comments"}
          disable={achivementDisable}
          value={state.Achievement}
          styles={{ margin: 0 }}
          type={isNumericAchivement ? "number" : "text"}
          multiline={!isNumericAchivement}
          minRows={!isNumericAchivement ? 2 : undefined}
          maxRows={!isNumericAchivement ? 5 : undefined}
          onChange={(value) => onChangeHandler(value, "Achievement")}
          onBlur={updateRating}
        />
      )}
    </Stack>
  );
}

export default AssessmentForm;
